import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTestLeefstijl = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="M10 34h20V6H16l-3 3-3 3z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m10 11.97 2.98-2.99L15.97 6v5.97zM27.59 24.5H18v-1h9.59zM27.59 18.5H18v-1h9.59zM27.59 30.5H18v-1h9.59z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M16 28h-4v4h4zM16 22h-4v4h4zM16 16h-4v4h4z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m18.348 27.36-4.496 4.353-2.217-2.372.73-.683 1.523 1.629 3.764-3.646zM31.63 8.58h-7.42v-1h8.42V16h-1z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTestLeefstijl);

export default ForwardRef;
